import { render } from "./newItem.vue?vue&type=template&id=1d1048f8&scoped=true"
import script from "./newItem.vue?vue&type=script&lang=js"
export * from "./newItem.vue?vue&type=script&lang=js"

import "./newItem.vue?vue&type=style&index=0&id=1d1048f8&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1d1048f8"]])

export default __exports__